module.exports = __webpack_public_path__ + "img/europe.52714f52.png";